const heroSlider = {
  error: Drupal.t('Something went wrong. Please try again later.'),
  featured: Drupal.t('Featured'),
  news: Drupal.t('News & Press'),
  productGroups: Drupal.t('Product Groups'),
};

export default heroSlider;
